import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export default class AngularMaterialHelperService {
	private dialog: MatDialog = inject(MatDialog);
	private snackBar: MatSnackBar = inject(MatSnackBar);
	
	getMaterialPanel() {
		return this.dialog;
	}
	
	getMaterialToast() {
		return this.snackBar;
	}
	
	getMaterialDialog() {
		return this.dialog;
	}
	
}